class BaseCollection {
  url = '';
  model = App.Models.BaseModel;

  constructor(modelArray) {
    this.models = new Array();

    modelArray && this.add(modelArray);
  }

  initialize = (attributes, options) => {
    options = options || {};
    this.init && this.init(attributes, options);
  }

  isEmpty = () => {
    return !this.models.length;
  }

  // Collection methods

  add = (data, options) => {
    if (!data) return;
    if(Array.isArray(data)) {
      data.forEach((item) => {
        const modelItem = new this.model;
        modelItem.set(item);
        this.addModel(modelItem);
      });
    } else if (data instanceof this.model) {
      this.addModel(data, options);
    } else {
      const modelItem = new this.model;
      modelItem.set(data);
      this.addModel(modelItem, options);
    }
  }

  addModel = (model, options) => {
    const index = this.models.findIndex(item => model.id ? (item.id === model.id) : (item.cid === model.cid));
    if (index >= 0) {
      this.models[index] = model;
    } else if(options && (options.at >= 0)) {
      this.models.splice(options.at, 0, model);
    } else {
      this.models.push(model);
    }
  }

  destroy = (model, {success, error} = {}) => {
    const ajax = new Monet.Ajax();
    ajax.url = model.url();
    ajax.method = 'DELETE';
    ajax.success = () => {
      this.remove(model);
      success && success();
    };
    ajax.error = error;
    ajax.send();
  }

  remove = (model) => {
    const index = this.models.findIndex(item => model.id ? (item.id === model.id) : (item.cid === model.cid));
    this.models.splice(index, 1);
  }

  reset = () => {
    this.models = new Array();
  }

  last = () => this.models[this.size() - 1];

  first = () => this.models[0];

  at = (index) => this.models[index];

  getById = (id) => {
    const index = this.models.findIndex(item => item.id == id);
    return this.at(index);
  }

  size = () => this.models.length;

  sort = () => {
    if (!this.comparator) throw Error("Cannot sort a set without a comparator");

    this.models.sort(this.comparator);
  }

  doAjax = (obj, url, success) => {
    var data = obj.filter || obj.data;
    var successFunc = success || ((data) => {
      this.add(data);
      if (obj.success) {
        obj.success(this);
      }
    });

    if (typeof data !== 'string') {
      data = data;
    }

    var ajax = new Monet.Ajax();
    ajax.url = url;
    ajax.method = obj.method || 'post';
    ajax.data = data;
    ajax.success = successFunc;
    ajax.error = function (xhr) {
      Monet.Configurations.errorNotification(null, xhr, null, null);
    };

    return ajax.send();
  }

  fetch = (obj) => {
    if (!obj.add) {
      this.reset();
    }
    obj.method = obj.type || 'GET';

    const url = (typeof this.url === "function") ? this.url() : this.url;

    this.doAjax(obj, url);
  }

  fetchWithCriteria = (obj) => {
    if (!obj.add) {
      this.reset();
    }

    this.doAjax(obj, this.url + '?criteria=' + obj.criteria);
  }

  filterWithCriteria = async (obj) => {
    await this.doAjax(obj, this.url + '/restrictions?criteria=' + obj.criteria);
  }

  filterWithRestrictions = (obj) => {
    var restrictionUrl = obj.restrictionUrl || '/restrictions';
    this.doAjax(obj, this.url + restrictionUrl + '?criteria=' + obj.criteria);
  }

  filterWithRestrictionsByHaveToMany = (obj) => {
    var criteria = null,
      filter = null,
      ajax,
      entityParentToUrl,
      attributeHasMany,
      attributeParent,
      attributesToCopy = [];

    if (obj) {
      ajax = new Monet.Ajax();

      if (obj.criteria) {
        criteria = obj.criteria;
      }

      if (obj.filter) {
        filter = JSON.stringify(obj.filter);
      }

      if (obj.entityParentToUrl) {
        entityParentToUrl = obj.entityParentToUrl;
      }

      if (obj.attributeHasMany) {
        attributeHasMany = obj.attributeHasMany;
      }

      if (obj.attributeParent) {
        attributeParent = obj.attributeParent;
      }

      if (obj.attributesToCopy) {
        attributesToCopy = obj.attributesToCopy;
      }

      ajax.url = entityParentToUrl + '/restrictions?criteria=' + criteria;
      ajax.method = 'post';
      ajax.data = filter;

      ajax.success = (data) => {
        if (obj.success && data) {
          data.forEach((dataItem) => {
            var item = dataItem;
            var tooManyItems = this.extractToManyRelationship(item, attributeHasMany);
            if (tooManyItems) {
              tooManyItems.forEach((tooManyItem) => {
                const model = new this.model();
                model.set(tooManyItem);
                if (attributeParent) {
                  model.set({ [attributeParent]: item });
                }

                attributesToCopy.forEach((property) => {
                  model.set({ [property]: item[property] });
                });
                this.add(model);
              });
            }
          });
          obj.success(this);
        }
      };
      ajax.error = function (xhr) {
        Monet.Configurations.errorNotification(null, xhr, null, null);
      };
      ajax.send();
    }
  }

  extractToManyRelationship = (item, fullPath) => {
    var pathArray = fullPath.split('.');
    var itemIsShallow = (pathArray.length === 1);
    var itemToReturn = item;
    if (itemIsShallow) {
      return item[pathArray[0]];
    } else {
      var path;
      while (true) {
        path = pathArray.shift();
        if (path) {
          itemToReturn = itemToReturn[path];
        } else {
          break;
        }
      }
    }
    return itemToReturn;
  }

  newCollectionByExtractProperties = (propertyRoot, additionalProperties) => {
    const newCollection = [];

    this.models.forEach((model) => {
      const obj = model.get(propertyRoot);
      if (additionalProperties && additionalProperties.length) {
        for (let j = 0; j < additionalProperties.length; j++) {
          obj[additionalProperties[j]] = model.get(additionalProperties[j]);
        }
      }
      newCollection.push(obj);
    });

    return newCollection;
  }

  forEach = (callback) => {
    this.models.forEach(callback);
  }

  map = (callback) => {
    return this.models.map(callback);
  }
}

App.Collections = App.Collections || {};
App.Collections.BaseCollection = BaseCollection;